
import { supabase } from "@/integrations/supabase/client";
import { QueryResult } from "../types";

/**
 * Queries related to contract values
 */
export const contractValueQueries = {
  // Get user contract value
  getUserContractValue: async (year?: number): Promise<QueryResult> => {
    try {
      const currentYear = year || new Date().getFullYear();
      const startOfYear = new Date(currentYear, 0, 1).toISOString();
      const endOfYear = new Date(currentYear, 11, 31, 23, 59, 59).toISOString();
      
      // Fetch contract values
      const { data: valueData, error: valueError } = await supabase
        .from('contracts')
        .select('expected_cost, currency_id, currencies:currency_id(id, code, symbol)')
        .gte('created_at', startOfYear)
        .lte('created_at', endOfYear);
      
      if (valueError) throw valueError;
      
      // Calculate total value and organize by currency
      let totalValue = 0;
      const valuesByCurrency: Record<string, { currencyId: string, total: number, symbol: string, code: string }> = {};
      
      valueData.forEach(contract => {
        const cost = parseFloat(String(contract.expected_cost || '0'));
        totalValue += cost;
        
        const currencyId = contract.currency_id || 'unknown';
        if (!valuesByCurrency[currencyId]) {
          valuesByCurrency[currencyId] = {
            currencyId,
            total: 0,
            symbol: contract.currencies?.symbol || '$',
            code: contract.currencies?.code || 'USD'
          };
        }
        valuesByCurrency[currencyId].total += cost;
      });
      
      // Get user's default currency
      const { data: preferences, error: prefError } = await supabase
        .from('user_preferences')
        .select('default_currency_id')
        .single();
      
      if (prefError && prefError.code !== 'PGRST116') {
        console.error('Error fetching user preferences:', prefError);
      }
      
      const defaultCurrencyId = preferences?.default_currency_id || null;
      
      return {
        data: { 
          totalValue,
          valuesByCurrency: Object.values(valuesByCurrency),
          defaultCurrencyId
        },
        error: null
      };
    } catch (error) {
      console.error("Error fetching user contract value:", error);
      return {
        data: { 
          totalValue: 0,
          valuesByCurrency: [],
          defaultCurrencyId: null
        },
        error
      };
    }
  }
};
